import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/offices/${ view }.vue`);
}


const Index = loadView( 'Index' );
const Create = loadView( 'Create' );
const officeView = loadView( 'View' );
const Edit = loadView( 'Edit' );


const officeRoutes = [
    {
        path: 'offices',
        name: 'api.office.getList',
        component: Index,
        meta: {
            middleware: permission,
            transitionName: 'slide',
        }
    },
    {
        path: 'offices/:id?/create',
        name: 'api.office.create',
        component: Create,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'offices/:id',
        name: 'api.office.get',
        component: officeView,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'offices/:id/edit',
        name: 'api.office.update',
        component: Edit,
        meta: {
            middleware: permission
        }
    },
];
export default officeRoutes;
